import React from 'react'
import { string, object, array, oneOfType } from 'prop-types'

const Col = () => <col width={'50%'} />

Col.displayName = 'Col'

Col.propTypes = {
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default Col
